export const META_PRICING_BRL = {
  MARKETING: 0.32,
  UTILITY: 0.09,
  AUTHENTICATION: 0.09,
} as const;

export type MetaTemplateCategory = keyof typeof META_PRICING_BRL;

export function estimateCampaignCost(category: MetaTemplateCategory, recipientCount: number): number {
  return META_PRICING_BRL[category] * recipientCount;
}
